import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import LeaseApiService from '../../services/apiService';

const PropertyDetails = ({ tableLoading, setCityList, setTransectionData, propertyCategory, transectionData, countriesList, ownerShip, propertyType, projectStatus, cityList, projectUse, community }) => {
    const apiService = new LeaseApiService();

    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            if (name === "firstName" || name === "lastName") {
                updatedData.fullName = `${updatedData.firstName || ""} ${updatedData.lastName || ""}`.trim();
            }
            return updatedData;
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setTransectionData(prev => ({ ...prev, [name]: value }));
        if (name === "country") {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'CitiesByCountry');
            params.append('CascadValue', value?.label);
            const res = await apiService.getApiParamater('PROPERTY_CASCAD', `?${params.toString()}`);
            setCityList(res?.data?.items)
        }
    }

    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Property No</label>
                        <input type="text" className="p-2 form-control w-75" disabled value={transectionData?.propertyNo} onChange={handleInputChange} name="propertyNo" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Name *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.propertyName} onChange={handleInputChange} name="propertyName" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Property Type *</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.propertyType}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'propertyType', value: selectedOption })}
                            options={propertyType?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Plot No</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.plotNo} onChange={handleInputChange} name="plotNo" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">OwnerShip</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.ownerShip}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'ownerShip', value: selectedOption })}
                            options={ownerShip?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Project Status</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.projectStatus}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'projectStatus', value: selectedOption })}
                            options={projectStatus?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Property Category *</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.category}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                            options={propertyCategory?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Plot Size </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.plotSize} onChange={handleInputChange} name="plotSize" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.remarks} onChange={handleInputChange} name="remarks" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Property Description</label>
                        <textarea type="text" className="p-2 form-control w-75" value={transectionData?.propertyDescription} onChange={handleInputChange} name="propertyDescription" />
                    </div>
                </div>
            </div>
            <div className={`border-box2 p-3`}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Country *</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.country}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'country', value: selectedOption })}
                            options={countriesList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Location</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.location} onChange={handleInputChange} name="location" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">City *</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.city}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'city', value: selectedOption })}
                            options={cityList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Area</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.area} onChange={handleInputChange} name="area" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Community *</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.community}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'community', value: selectedOption })}
                            options={community?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Longitude</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.longitude} onChange={handleInputChange} name="longitude" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Latitude</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.latitude} onChange={handleInputChange} name="latitude" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Video</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.video} onChange={handleInputChange} name="video" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PropertyDetails